import styled from 'styled-components';

export const FormSection = styled.div`
  margin-bottom: 28px;

  h3 {
    font-size: var(--text-base);
    font-weight: 700;
    font-family: var(--font-brand);
    color: var(--text-primary);
    margin-bottom: 14px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--border-light);
  }
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const DocumentsSection = styled.div`
  margin-bottom: 28px;
  background: var(--primary-subtle);
  border-radius: var(--radius-md);
  padding: 20px;

  h3 {
    font-size: var(--text-base);
    font-weight: 700;
    font-family: var(--font-brand);
    color: var(--primary-dark);
    margin-bottom: 6px;
  }

  > p {
    font-size: var(--text-sm);
    color: var(--text-secondary);
    margin-bottom: 16px;
  }
`;

export const FileUpload = styled.div`
  margin-bottom: 10px;

  label {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    background: var(--bg-card);
    border: 1.5px dashed var(--border-medium);
    border-radius: var(--radius-md);
    padding: 12px 16px;
    cursor: pointer;
    transition: border-color var(--transition-fast);

    &:hover { border-color: var(--primary); }

    > span:first-child {
      font-size: var(--text-sm);
      font-weight: 600;
      color: var(--text-primary);
    }

    input[type='file'] {
      font-size: var(--text-xs);
      color: var(--text-muted);
      max-width: 220px;
    }

    .file-name {
      font-size: var(--text-xs);
      color: var(--success-dark);
      font-weight: 600;
    }
  }
`;
